module.exports = __webpack_public_path__ + "static/media/fn3.4075595f.png";